export function Filler() {
  return <div class="w-full h-full" />;
}
